import React from 'react'
import { Dimmer, Icon, Loader } from 'semantic-ui-react'

export default () => (
  <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    <Dimmer active>
      <Loader>Cargando datos...</Loader>
    </Dimmer>
  </div>
)
